'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Field = function (_Component) {
  _inherits(Field, _Component);

  function Field() {
    var _temp, _this, _ret;

    _classCallCheck(this, Field);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this._ref = null, _this._onClick = function () {
      // get the input
      var input = _this._ref.querySelector('.form-control');
      if (!input) {
        return;
      }

      // get the fieldset
      var fieldset = _this._ref.closest('fieldset');
      if (!fieldset) {
        return;
      }

      // check if the input or fieldset is disabled
      if (input.hasAttribute('disabled') || fieldset.hasAttribute('disabled')) {
        return;
      }

      // focus the input
      input.focus();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  // focus the input inside if this section is clicked


  Field.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        children = _props.children,
        className = _props.className,
        span = _props.span,
        props = _objectWithoutProperties(_props, ['children', 'className', 'span']);

    var cl = (0, _classnames2.default)('tforms--field', className);
    return _react2.default.createElement(
      'div',
      _extends({
        ref: function ref(c) {
          return _this2._ref = c;
        },
        className: cl,
        onClick: this._onClick,
        style: { flexGrow: Number(span), flexBasis: Number(span) }
      }, props),
      children
    );
  };

  return Field;
}(_react.Component);

Field.defaultProps = {
  span: '1'
};

exports.default = Field;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/tforms/lib/field.js
// module id = 823
// module chunks = 0